import CreateShopArticleTaxRequestModelBase from '../_generated/modelBases/create-shop-article-tax-request-model-base';

export default class CreateShopArticleTaxRequestModel extends CreateShopArticleTaxRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
